export default __webpack_public_path__ + "static/media/pro-elevate-red-banner-1.33eb168c.jpg";